var PLACEMENTS = {
    SHOW_ON_HOVER: 'SHOW_ON_HOVER',
    SHOW_BELOW: 'SHOW_BELOW',
    SHOW_ABOVE: 'SHOW_ABOVE',
    SHOW_ON_THE_RIGHT: 'SHOW_ON_THE_RIGHT',
    SHOW_ON_THE_LEFT: 'SHOW_ON_THE_LEFT',
};
var hasAbovePlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ABOVE) >= 0;
};
var hasBelowPlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_BELOW) >= 0;
};
var hasHoverPlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_HOVER) >= 0;
};
var hasRightPlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_THE_RIGHT) >= 0;
};
var hasLeftPlacement = function (placement) {
    return String(placement).indexOf(PLACEMENTS.SHOW_ON_THE_LEFT) >= 0;
};
var hasVerticalPlacement = function (placement) {
    return hasAbovePlacement(placement) || hasBelowPlacement(placement);
};
var hasHorizontalPlacement = function (placement) {
    return hasRightPlacement(placement) || hasLeftPlacement(placement);
};
var isVerticalPlacement = function (placement) {
    return (hasAbovePlacement(placement) || hasBelowPlacement(placement)) &&
        !hasHorizontalPlacement(placement) &&
        !hasHoverPlacement(placement);
};
var isHorizontalPlacement = function (placement) {
    return (hasRightPlacement(placement) || hasLeftPlacement(placement)) &&
        !hasVerticalPlacement(placement) &&
        !hasHoverPlacement(placement);
};
var isAbovePlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ABOVE;
};
var isBelowPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_BELOW;
};
var isHoverPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_HOVER;
};
var isRightPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_THE_RIGHT;
};
var isLeftPlacement = function (placement) {
    return String(placement) === PLACEMENTS.SHOW_ON_THE_LEFT;
};
export default PLACEMENTS;
export { hasAbovePlacement, hasBelowPlacement, hasHoverPlacement, hasRightPlacement, hasLeftPlacement, hasVerticalPlacement, hasHorizontalPlacement, isAbovePlacement, isBelowPlacement, isHoverPlacement, isRightPlacement, isLeftPlacement, isVerticalPlacement, isHorizontalPlacement, };
//# sourceMappingURL=placements.js.map